export default {
	common: {
		changePwd: "Change IDM Password",
		account: "Account Management",
		approval: "IDM Approval",
		approvalDetail: "Approval Details",
		approvalDelegate: "Assignee Information",
		request: "Request Access",
		selectAccess: "Select Access",
		selectPerson: "Select Person",
		records: "Request Records",
		recordDetail: "Record Details",
		idmPerson: "My Profile",
		myAccess: "My Roles",
		idmHome: "IDM Home"
	},
	homepage: {
		refresh_tip: "Pull down for latest data!",
		refresh_text: "Refresh Successfully",
		refresh_success: "Refresh Successfully!",
		refresh_failed: "Refresh Failed!",
		password: "Change Password",
		account: "Unlock Account",
		request: "Request Access",
		approval: "Approval Access",
		access: "My Roles",
		person: "My Profile"
	},
	password: {
		userName: "IDM Account",
		newPassword: "New Password",
		placeholder_1: "Please enter new password",
		confirmPassword: "Confirm Password",
		placeholder_2: "Please enter new password again",
		button: "Submit",
		requirement: "Password Requirements:",
		rule_1: "1.The password length should be no less than 12 characters and no more than 40 characters;",
		rule_2: "2.The password must contain at least 1 number, 1 lowercase letter, 1 uppercase letter, and it is preferred to include special characters;",
		rule_3: "3.The password cannot contain the IDM account;",
		rule_4: "4.The password cannot use the last 3 historical passwords that have been used;",
		rule_5: "5.The password must not contain simple and easily guessable sequences such as 123, abc, etc.",
		rule_message_1: "The password cannot be empty",
		rule_message_2: "The new password must be between 12 and 40 characters long, and must include at least 1 number, 1 lowercase letter, and 1 uppercase letter",
		message_1: "The two passwords entered do not match!",
		message_2: "The confirmation password cannot be empty",
		message_3: "The password cannot be empty!",
		message_4: "The two passwords entered do not match, modification failed!",
		message_5: "Password modification successful!"
	},
	person: {
		picture: "Tap avatar to change photo",
		picturePreview: "New Avatar Preview:",
		confirmBtn: "Confirm Change",
		cancelBtn: "Cancel",
		account: "Account",
		name: "Name",
		displayName: "Display Name",
		department: "Department",
		email: "Email",
		mobile: "Mobile No.",
		tel: "Ext.",
		lang: "Preferred Language",
		manager: "Line Manager",
		delegate: "Delegate",
		delegator: "Delegator",
		delete_button: "Delete",
		title: "Prompts",
		delete_message: "Confirm deletion of this delegate?",
		add_button: "Add Delegate",
		manageStatus: "Administrative Status",
		accountStatus: "Account Status",
		enable: "enabled",
		disable: "disabled",
		lock: "locked",
		lockTo: "locked to",
		update: "Change",
		confirmText: "Confirm Change",
		displayName_title: "Modify Display Name",
		displayName_placeholder: "Please enter a new display name",
		mobile_title: "Modify Mobile Number",
		mobile_placeholder: "Please enter a new mobile number",
		tel_title: "Modify Extension Number",
		tel_placeholder: "Please enter a new extension number",
		search_placeholder: "Search by employee No. or name",
		search: "Search",
		loading_text: "searching...",
		toast_message_1: "The search content cannot be empty!",
		toast_message_2: "No information on this person was found!",
		toast_message_3: "Successfully modified, under approval...",
		toast_message_4: "Modified failed!",
		toast_message_5: "Modified successfully!",
		toast_message_6: "Deleted successfully!",
		toast_message_7: "Deletion failed!",
		toast_message_8: "Added successfully!",
		toast_message_9: "Added failed!",
		toast_message_10: "Delegate information cannot be empty!",
		toast_message_11: "Direct supervisor information cannot be empty!"
	},
	account: {
		refresh_text: "Refresh Successfully",
		refresh_tip: "Pull down for latest data!",
		refresh_success: "Refresh Successfully!",
		refresh_failed: "Refresh Failed!",
		description: "No account information available",
		label: "Account",
		unlock: "Unlock",
		message_1: "Query for account exceptions!",
		message_2: "{accountName} account unlocked successfully!",
		message_3: "{accountName} account unlocked failed!",
	},
	access: {
		placeholder: "Please enter the access name to search",
		search: "Search",
		description: "No access information",
		accessName: "Access Name",
		accessStatus: "Activation Status",
		enable: "enable",
		disable: "disable",
		startFrom: "From",
		endTo: "to",
		message: "No matching search records found!",
	},
	approval: {
		description: "No pending approval work items",
		detail_button: "See Details",
		query_button: "All Cases",
		loading_text: "Querying...",
		loading_message: "Loading...",
		message_1: "No related data found!",
		message_2: "Query successfully!",
		message_3: "Query failed!",
		detail: {
			submiterName: "Requestor",
			submiterNo: "Requestor ID",
			requesterName: "Applicant",
			requesterNo: "Applicant ID",
			status: "Status",
			content: "Items",
			outcome_label: "Result",
			outcome_1: "Approved",
			outcome_2: "Rejected",
			outcome_3: "Cancelled",
			outcome_4: "Pending",
			validFrom: "Effective Date",
			validTo: "Expiration Date",
			remark: "Request Comments",
			comment: "Approval Comments",
			comment_placeholder: "Please enter approval comments",
			workflow: "Process",
			cancel_button: "Cancel",
			approve_button: "Approve",
			reject_button: "Reject",
			delegate_button: "Forward",
			title: "Prompts",
			cancel_message: "Are you sure you want to cancel this approval item?",
			approve_message: "Are you sure you want to approve this approval item?",
			reject_message: "Are you sure you want to reject this approval item?",
			message_1: "Cancel successfully!",
			message_2: "Cancel failed!",
			message_3: "Operation successful!",
			message_4: "Operation failed!"
		},
		delegate: {
			assignee: "Assignee",
			placeholder: "Click to search for assignee",
			rule_message: "Please enter the assignee",
			search_placeholder: "Enter the assignee ID or name",
			search_loading_text: "searching...",
			forward_loading_text: "forwarding...",
			search_button: "Search",
			forward_comment: "Forwarding Comment",
			forward_placeholder: "Please enter the forwarding comment",
			confirm_forward: "Confirm Forwarding",
			message_1: "Please enter employee ID or name to search!",
			message_2: "No information was found for this employee!",
			message_3: "Forwarding successfully!",
			message_4: "Forwarding failed!",
			message_5: "Please fill in the required fields!",
			message_6: "You cannot delegate to yourself!"
		}
	},
	request: {
		forSelf: "Myself",
		forOther: "Teammates",
		records: "Records",
		record: {
			description: "No pending application records",
			detail_button: "See Details",
			query_button: "All Records",
			loading_text: "Querying...",
			loading_message: "Loading...",
			message_1: "No related data found!",
			message_2: "Query successfully!",
			message_3: "Query failed!"
		},
		access: {
			person: "Applicant",
			accessName: "Access name",
			rule_message: "Please fill in the access information",
			placeholder_1: "Click to search for an access",
			placeholder_2: "Please enter an access name to search",
			loading_text_1: "searching...",
			search_button: "Search",
			valid_label: "Valid duration",
			placeholder_3: "Please select the valid duration",
			validTime: "Effective Date",
			placeholder_4: "Please select the effective date",
			title: "Select Time",
			expiryTime: "Expiration Date",
			placeholder_5: "Please select the expiration date",
			comment: "Request Comment",
			placeholder_6: "Please enter request comment",
			loading_text_2: "Applying...",
			request_button: "Submit",
			one_day: "1 day",
			one_week: "1 week",
			one_month: "1 month",
			one_year: "1 year",
			custom: "Custom length",
			message_1: "No relevant access information found!",
			message_2: "Application successful!",
			message_3: "Application failed!",
			message_4: "Please fill in the required fields!"
		},
		person: {
			user: "Applicant",
			rule_message: "Please fill in the applicant information",
			placeholder_1: "Click to search person",
			placeholder_2: "Please enter ID or name to search",
			loading_text: "searching...",
			search_button: "Search",
			submit_button: "Sumbit",
			message_1: "Search content cannot be empty!",
			message_2: "No information found on this person!",
			message_3: "Please fill in the required fields!"
		},
		detail: {
			submiterName: "Requestor",
			submiterNo: "Requestor ID",
			requesterName: "Applicant",
			requesterNo: "Applicant ID",
			status: "Status",
			content: "Items",
			outcome_label: "Result",
			outcome_1: "Approved",
			outcome_2: "Rejected",
			outcome_3: "Cancelled",
			outcome_4: "Pending",
			validFrom: "Effective Date",
			validTo: "Expiration Date",
			remark: "Request Comments",
			workflow: "Process",
			cancel_button: "Cancel Request",
			title: "Prompts",
			cancel_message: "Confirm to cancel this request?",
			message_1: "Cancel Successfully!",
			message_2: "Cancel Failed!"
		}

	}

};
